import cn from 'classnames';
import Slider, { SliderOptions } from '@dealroadshow/uikit-slider';
import { TabLink as NextNavLink } from '@framework/router/Next/Link';
import styles from './benefits.module.scss';
import benefitsPattern from './assets/benefitsPattern.svg';

import { savingsGuaranteeFootnoteUrl } from '../constants';

const defaultCollection = [
  {
    key: 'savingsGuarantee',
    title: '20% Savings Guarantee',
    description: (
      <>
        <p>
          We’ll beat any quoted price for a comparable VDR
          by&nbsp;
          <NextNavLink to={ savingsGuaranteeFootnoteUrl }>
            20% or more
          </NextNavLink>&nbsp;*
        </p>
        <p>
          We guarantee upfront savings with no contractual commitments.{ ' ' }
          This may save you tens of thousands per year. New customers only.
        </p>
      </>
    ),
  },
  {
    key: 'trialPeriod',
    title: 'Free 30-Day Trial Period',
    description: (
      <>
        <p>See if DealVDR is the right fit with a <span>free 30-day trial</span>.</p>
        <p>
          No credit cards, no commitments and access to 100% of features and functionality,{ ' ' }
          including our fanatical 24x7 U.S. based support.
        </p>
      </>
    ),
  },
  {
    key: 'migrationServices',
    title: 'Free Migration Services',
    description: (
      <>
        <p>
          We provide <span>free migration</span> services and credit pre-paid duration on your existing data room.
        </p>
        <p>
          We’ll replicate all existing files, folders, users and permissions so you can start using DealVDR today.
        </p>
      </>
    ),
  },
];

const sliderSettings: SliderOptions = {
  pagination: {
    clickable: true,
    enabled: true,
  },
  navigation: false,
  loop: false,
  speed: 500,
  slidesPerView: 1,
  breakpoints: {
    769: {
      slidesPerView: 3,
    },
  },
};

interface IProps {
  className?: string,
  titleClassName?: string,
  descriptionClassName?: string,
  collection?: {
    key: string,
    title: string,
    description: React.ReactNode,
  }[],
}

const Benefits = ({
  className = '',
  titleClassName = '',
  descriptionClassName = '',
  collection = defaultCollection,
  ...otherProps
}: IProps) => {
  const props = { className, titleClassName, descriptionClassName, collection, ...otherProps };
  const renderBenefitItem = (item: { key: string, title: string, description: React.ReactNode }) => (
    <div className={ styles.benefit }>
      <div className={ styles.benefitContainer }>
        <div className={ cn(styles.benefitTitle, props.titleClassName) }>{ item.title }</div>
        <div className={ cn(styles.benefitDescription, props.descriptionClassName) }>
          { item.description }
        </div>
      </div>
    </div>
  );

  return (
    <div className={ cn(styles.benefitsContainer, props.className) }>
      <img className={ styles.benefitsPattern } src={ benefitsPattern.src } />
      <Slider
        options={ sliderSettings }
        collection={ collection }
        getItemKey={ (item) => item.key }
        renderItem={ renderBenefitItem }
        slideClassName={ styles.benefitSlide }
        wrapperClassName={ styles.benefitSliderWrapper }
      />
    </div>
  );
};

export default Benefits;
